import React, { ReactNode } from "react";
import UtilityPageLayout from "./UtilityPageLayout";
import { FeatureFlagName } from "../../../../tenant/features/featureFlags";
import { useFeatureFlags } from "../../../../tenant/features/useFeatureFlag";

interface AdminFeatureGateProps {
	feature: FeatureFlagName;
	/** Page title to show above the locked state. */
	title: string;
	children: ReactNode;
}

/**
 * Route-level counterpart of UtilityPageLayout's `feature` prop, for pages that draw
 * their own header instead of using the layout. Renders the page when the flag is on;
 * otherwise the standard title + tooltip + locked state, so the URL stays reachable
 * and the user sees why there is nothing behind it.
 */
const AdminFeatureGate: React.FC<AdminFeatureGateProps> = ({ feature, title, children }) => {
	const { isEnabled, isLoading } = useFeatureFlags();
	if (isLoading) return null;
	if (isEnabled(feature)) return <>{children}</>;
	return (
		<UtilityPageLayout title={title} feature={feature}>
			{null}
		</UtilityPageLayout>
	);
};

export default AdminFeatureGate;
